import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

export const SignalTrendChart = ({ brandName, points }) => {
  const data = points.map((d) => ({
    date: new Date(d.created_at).toLocaleDateString(undefined, { month: "short", day: "numeric" }),
    score: d.visibility_score,
  }));
  return (
    <div className="rounded-lg border border-surface-border bg-surface-card p-4" data-testid={`signal-trend-${brandName}`}>
      <p className="mb-2 text-sm font-semibold text-white">{brandName} &mdash; Live Signal Trend</p>
      <ResponsiveContainer width="100%" height={160}>
        <LineChart data={data}>
          <CartesianGrid stroke="#1E293B" strokeDasharray="3 3" />
          <XAxis dataKey="date" stroke="#64748B" fontSize={11} />
          <YAxis domain={[0, 100]} stroke="#64748B" fontSize={11} width={28} />
          <Tooltip contentStyle={{ background: "#0F1420", border: "1px solid #1E293B", fontSize: 12 }} />
          <Line type="monotone" dataKey="score" stroke="#FF2A3B" strokeWidth={2} dot={{ r: 3 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
